// extracted by mini-css-extract-plugin
export default {"separator":"separator__T29F1"};